import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["wrapperClass", "linkClass", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import { BreadcrumbsForFooter } from "@/components/Breadcrumbs";
import Copyrights from "@/components/Copyrights";
import config from "@/lib/config";
import { companyLink, helpLink, maintenanceLink, privacyLink } from "@/lib/constants";
import styles from "@/styles/Footer.module.scss";
import classnames from "classnames";
import { useRouter } from "next/router";
import { useMemo } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var XLogo = function XLogo(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsxs("style", {
      type: "text/css",
      children: [".x_logo_footer_svg", `{`, "fill:#FFFFFF;", `}`]
    }), /*#__PURE__*/_jsx("path", {
      className: "x_logo_footer_svg",
      d: "M714.2,519.3L1160.9,0H1055L667.1,450.9L357.3,0H0l468.5,681.8L0,1226.4h105.9l409.6-476.2l327.2,476.2H1200 L714.2,519.3L714.2,519.3z M569.2,687.8l-47.5-67.9L144,79.7h162.6l304.8,436l47.5,67.9l396.2,566.7H892.5L569.2,687.8L569.2,687.8z "
    })]
  }));
};
XLogo.defaultProps = {
  version: "1.1",
  id: "レイヤー_1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 1200 1227",
  style: {
    enableBackground: "new 0 0 1200 1227"
  },
  xmlSpace: "preserve"
};
function FooterLink(props) {
  const {
      wrapperClass,
      linkClass,
      children
    } = props,
    linkProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_jsx("li", {
    className: classnames(styles.wrapper, wrapperClass),
    children: /*#__PURE__*/_jsx("a", _objectSpread(_objectSpread({
      className: classnames(styles.link)
    }, linkProps), {}, {
      children: children
    }))
  });
}
function FooterUpper(_ref) {
  let {
    isLoginPage
  } = _ref;
  if (isLoginPage) return null;
  const help = useMemo(() => helpLink(), []);
  const maintenance = useMemo(() => maintenanceLink(), []);
  return /*#__PURE__*/_jsx("div", {
    className: `${styles.box} ${styles.upper}`,
    children: /*#__PURE__*/_jsxs("ul", {
      className: styles.links,
      children: [/*#__PURE__*/_jsx(FooterLink, {
        href: help,
        target: "_blank",
        rel: "noopener noreferrer",
        children: "\u30D8\u30EB\u30D7"
      }), /*#__PURE__*/_jsx(FooterLink, {
        href: "/static/feature/constant/environment",
        children: "\u52D5\u4F5C\u74B0\u5883"
      }), /*#__PURE__*/_jsx(FooterLink, {
        href: maintenance,
        children: "\u30E1\u30F3\u30C6\u30CA\u30F3\u30B9\u60C5\u5831"
      }), /*#__PURE__*/_jsxs(FooterLink, {
        wrapperClass: styles.twitter,
        linkClass: styles.twitter,
        href: "https://x.com/SPOOX_enta",
        target: "_blank",
        rel: "noopener noreferrer",
        children: [/*#__PURE__*/_jsx(XLogo, {
          className: styles.Icon
        }), "SPOOX\u516C\u5F0FX\uFF08\u65E7Twitter\uFF09"]
      })]
    })
  });
}
function FooterLower(_ref2) {
  let {} = _ref2;
  const privacy = useMemo(() => privacyLink(), []);
  const year = new Date().getFullYear();
  const company = useMemo(() => companyLink(), []);
  return /*#__PURE__*/_jsxs("div", {
    className: `${styles.box} ${styles.lower}`,
    children: [/*#__PURE__*/_jsxs("ul", {
      className: styles.links,
      children: [/*#__PURE__*/_jsx(FooterLink, {
        href: company,
        target: "_blank",
        rel: "noopener noreferrer",
        children: "\u4F1A\u793E\u6982\u8981"
      }), /*#__PURE__*/_jsx(FooterLink, {
        href: "/static/legal/service_term",
        children: "SPOOX\u5229\u7528\u898F\u7D04"
      }), /*#__PURE__*/_jsxs(FooterLink, {
        href: "/static/legal/valueplan_term",
        children: [config.valuePlan.text, "\uFF08\u30B9\u30AB\u30D1\u30FC\u5411\u3051\u63D0\u643A\u30E2\u30C7\u30EB\uFF09\u5229\u7528\u898F\u7D04"]
      }), /*#__PURE__*/_jsx(FooterLink, {
        href: privacy,
        target: "_blank",
        rel: "noopener noreferrer",
        children: "\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u30DD\u30EA\u30B7\u30FC"
      }), /*#__PURE__*/_jsx(FooterLink, {
        href: "/static/legal/sct_law",
        children: "\u7279\u5B9A\u5546\u53D6\u5F15\u6CD5\u306B\u57FA\u3065\u304F\u8868\u8A18\uFF08\u8FD4\u54C1\u7279\u7D04\u542B\u3080\uFF09"
      }), /*#__PURE__*/_jsx(FooterLink, {
        href: "/static/legal/site_policy",
        children: "\u30B5\u30A4\u30C8\u30DD\u30EA\u30B7\u30FC"
      })]
    }), /*#__PURE__*/_jsxs("p", {
      className: styles.copyright,
      children: ["COPYRIGHT \xA9 2011-", year, " SKY PERFECT JSAT CORPORATION ALL RIGHTS RESERVED."]
    }), /*#__PURE__*/_jsx(Copyrights, {})]
  });
}
function Footer() {
  const router = useRouter();
  const isLoginPage = (() => {
    return router.pathname == "/login";
  })();
  return /*#__PURE__*/_jsxs("footer", {
    className: styles.footer,
    role: "contentinfo",
    children: [/*#__PURE__*/_jsx(BreadcrumbsForFooter, {}), /*#__PURE__*/_jsx(FooterUpper, {
      isLoginPage
    }), /*#__PURE__*/_jsx(FooterLower, {})]
  });
}
export default Footer;